(() => {
  // ---------- CONFIG ----------
  const API_VERSION = '2025-10';
  const STOREFRONT_TOKEN = 'd12e4fec79d72c48e5363d9936863cf1';
  const SHOP_ORIGIN = window.location.hostname;
  const GRAPHQL_URL = `https://${SHOP_ORIGIN}/api/${API_VERSION}/graphql.json`;

  // ---------- DOM ----------
  const input = document.getElementById('ipn-search-input');
  const suggestions = document.getElementById('ipn-suggestions');
  const resultsContainer = document.getElementById('ipn-search-results');
  const stats = document.getElementById('ipn-search-stats');

  if (!input || !suggestions || !resultsContainer || !stats) {
    console.warn('[IPN-search] Missing required DOM elements (#ipn-search-input, #ipn-suggestions, #ipn-search-results, #ipn-search-stats). Aborting.');
    return;
  }

  // If we don't already have a container wrapper, add a small wrapper around input for controls
  let controlsWrapper = input.closest('.ipn-search-controls');
  if (!controlsWrapper) {
    controlsWrapper = document.createElement('div');
    controlsWrapper.className = 'ipn-search-controls';
    // insert the wrapper and move input into it
    input.parentNode.insertBefore(controlsWrapper, input);
    controlsWrapper.appendChild(input);
  }

  // Create Search + Reset buttons (if not already present)
  let searchBtn = controlsWrapper.querySelector('.ipn-search-btn');
  let resetBtn = controlsWrapper.querySelector('.ipn-reset-btn');
  if (!searchBtn) {
    searchBtn = document.createElement('button');
    searchBtn.type = 'button';
    searchBtn.className = 'ipn-search-btn btn';
    searchBtn.textContent = 'SEARCH';
    // append after input
    input.insertAdjacentElement('afterend', searchBtn);
  }
  if (!resetBtn) {
    resetBtn = document.createElement('button');
    resetBtn.type = 'button';
    resetBtn.className = 'ipn-reset-btn btn';
    resetBtn.textContent = 'RESET';
    searchBtn.insertAdjacentElement('afterend', resetBtn);
  }

  // ---------- debug area ----------
  let debugArea = document.getElementById('ipn-debug-area');
  if (!debugArea) {
    debugArea = document.createElement('div');
    debugArea.id = 'ipn-debug-area';
    debugArea.style.marginTop = '10px';
    debugArea.style.color = '#a00';
    debugArea.style.fontSize = '13px';
    resultsContainer.parentNode && resultsContainer.parentNode.insertBefore(debugArea, resultsContainer.nextSibling);
  }

  // Load more button container (inserted below results)
  let loadMoreHolder = document.getElementById('ipn-load-more-holder');
  if (!loadMoreHolder) {
    loadMoreHolder = document.createElement('div');
    loadMoreHolder.id = 'ipn-load-more-holder';
    loadMoreHolder.style.textAlign = 'center';
    loadMoreHolder.style.marginTop = '18px';
    resultsContainer.parentNode && resultsContainer.parentNode.appendChild(loadMoreHolder);
  }

  // Create Load more button (hidden initially)
  let loadMoreBtn = document.getElementById('ipn-load-more');
  if (!loadMoreBtn) {
    loadMoreBtn = document.createElement('button');
    loadMoreBtn.id = 'ipn-load-more';
    loadMoreBtn.type = 'button';
    loadMoreBtn.textContent = 'Load more';
    loadMoreBtn.style.display = 'none';
    loadMoreBtn.className = 'btn';
    loadMoreHolder.appendChild(loadMoreBtn);
  }

  // ---------- inline styles (updated to position dropdown below input+buttons) ----------
  const STYLE_ID = 'ipn-search-inline-styles';
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.innerHTML = `
      .ipn-search-controls {
        display: flex;
        gap: 8px;
        align-items: center;
        margin-bottom: 12px;
        position: relative; /* allows absolutely positioned dropdown */
      }
      #ipn-search-results { grid-template-columns: auto !important; }
      .ipn-search-controls input#ipn-search-input {
        flex: 1 1 auto;
        min-width: 220px;
        position: relative;
        z-index: 2;
        border: 2px solid #ff5f00 !important;
      }
      .ipn-search-btn, .ipn-reset-btn {
        background: var(--btn1-hover-bg-cl);
        color: white;
        border: none;
        padding: 10px 14px;
        cursor: pointer;
        border-radius: 2px;
        font-weight: 500;
        z-index: 2;
      }
      .ipn-reset-btn { background: #ff7b3a; }
      .ipn-suggestions {
        position: absolute;
        top: 100%;
        left: 0;
        width: 72%;
        z-index: 9999;
        margin-top: 4px;
        background: #fff;
        box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        border-radius: 2px;
        overflow: hidden;
        list-style: none;
        padding: 0;
      }
      .ipn-suggestion-item {
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 10px 12px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
      }
      .ipn-suggestion-item:hover { background: #fafafa; }
      .ipn-suggestion-thumb {
        width: 56px;
        height: 48px;
        flex: 0 0 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: #f6f6f6;
      }
      .ipn-suggestion-thumb img { max-width: 100%; object-fit: contain; }
      .ipn-suggestion-meta { flex: 1 1 auto; min-width: 0; }
      .ipn-suggestion-title {
        font-size: var(--heading-size-h5);
        font-weight: var(--heading-5-weight);
        color: #111;
        line-height: 1.2;
        max-height: 36px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .ipn-suggestion-url { display: block; font-size: 12px; color: #777; margin-top: 4px; }
      .ipn-suggestion-price {
      font-size: var(--body-14);
        margin-top: 8px;
        margin-left: auto;
        flex: 0 0 auto;
      }
      #ipn-search-stats { margin-bottom:30px;text-align: center; font-size: var(--heading-size-h2); font-weight: var(--heading-2-weight); }
      .btn.btn-add-to-cart .svg-loading { display:none; }
      .btn.btn-add-to-cart.pending .svg-cart { display:none; }
      .btn.btn-add-to-cart.pending .svg-loading { display:inline-block; }

      /* small load more style */
      #ipn-load-more { padding: 10px 16px; border-radius:4px; background:#ff7b3a; color: white; border:none; cursor:pointer; }
      #ipn-load-more[disabled] { opacity:0.6; cursor:default; }
    `;
    document.head.appendChild(style);
  }

  // ---------- helpers ----------
  function debounce(fn, wait = 250) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  }
  function escapeForShopify(s = '') { return (s+'').replace(/(["\\():])/g, '\\$1'); }
  function escapeHtml(s = '') { return (s+'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function formatMoneyAmt(amount, currency) {
    if (amount === null || amount === undefined || amount === '') return '';
    const n = parseFloat(amount);
    if (isNaN(n)) return amount;
    return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (currency ? ` ${currency}` : '');
  }
  function variantIdToPlain(variantId) {
    if (!variantId) return variantId;
    const str = String(variantId).trim();
    if (/^\d+$/.test(str)) return str;
    let m = str.match(/\/([0-9]+)(?:$|[^\d])/);
    if (m && m[1]) return m[1];
    try {
      const decoded = atob(str);
      m = decoded.match(/\/([0-9]+)(?:$|[^\d])/);
      if (m && m[1]) return m[1];
      m = decoded.match(/([0-9]{4,})/);
      if (m && m[1]) return m[1];
    } catch (e) { /* not base64 */ }
    m = str.match(/([0-9]{4,})/);
    if (m && m[1]) return m[1];
    return str;
  }

  // Exact-match helpers
  function variantsFor(term) {
    term = (term || '').trim();
    if (!term) return [];
    return [term];
  }
  function buildQueryString(term) {
    const t = (term || '').trim();
    if (!t) return '';
    const vs = variantsFor(t);
    const parts = vs.map(v => `body:"${escapeForShopify(v)}"`);
    const fallback = vs.map(v => `(title:"${escapeForShopify(v)}" OR variants.sku:"${escapeForShopify(v)}")`);
    return [...parts, ...fallback].join(' OR ');
  }

  // ---------- GraphQL query (pageInfo included) ----------
  const GQL = `
    query SearchProducts($query: String!, $first: Int!, $after: String) {
      search(query: $query, types: PRODUCT, first: $first, after: $after) {
        totalCount
        pageInfo { hasNextPage endCursor }
        edges {
          node {
            ... on Product {
              id
              title
              handle
              description
              images(first:2) { edges { node { url } } }
              priceRange { minVariantPrice { amount currencyCode } }
              variants(first:1) {
                edges {
                  node {
                    id
                    availableForSale
                    sku
                    image { url }
                    priceV2 { amount currencyCode }
                    compareAtPriceV2 { amount currencyCode }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  async function runSearchGraphQL(queryString, first = 20, after = null) {
    console.debug('[IPN] GraphQL request:', queryString, { first, after });
    try {
      const res = await fetch(GRAPHQL_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: GQL, variables: { query: queryString, first, after } })
      });

      const textPreview = await res.clone().text().catch(()=>null);
      console.debug('[IPN] GraphQL HTTP', res.status, textPreview && textPreview.slice ? textPreview.slice(0,1000) : textPreview);

      if (!res.ok) {
        const t = await res.text().catch(()=>res.statusText);
        throw new Error(`GraphQL HTTP ${res.status}: ${t}`);
      }

      const json = await res.json();
      if (json.errors && json.errors.length) {
        const summary = json.errors.map(e => e.message).join(' | ');
        const err = new Error('GraphQL errors: ' + summary);
        err.details = json.errors;
        throw err;
      }

      return json.data && json.data.search ? json.data.search : null;
    } catch (err) {
      throw err;
    }
  }

  // Predictive fallback
  async function runPredictiveSuggest(term, limit = 6) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=${limit}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      const txt = await res.clone().text().catch(() => null);
      console.debug('[IPN] predictive HTTP', res.status, txt && (txt.length>200 ? txt.slice(0,200) : txt));
      if (!res.ok) {
        const t = await res.text().catch(()=>res.statusText);
        throw new Error(`Predictive HTTP ${res.status}: ${t}`);
      }
      const json = await res.json();
      if (json && json.resources && json.resources.results && json.resources.results.products) return json.resources.results.products;
      if (json && json.products) return json.products;
      return [];
    } catch (err) {
      console.warn('[IPN] predictive fallback failed', err);
      return [];
    }
  }

  // ---------- rendering helpers ----------
  function createProductCardNode(p) {
    const variantEdge = (p.variants && p.variants.edges && p.variants.edges[0]) || null;
    const variant = variantEdge ? variantEdge.node : null;

    const rawVariantId = variant && variant.id ? String(variant.id) : '';
    const plainVariantId = variantIdToPlain(rawVariantId);

    const imageUrl = (p.images && p.images.edges && p.images.edges[0] && p.images.edges[0].node && p.images.edges[0].node.url) || (variant && variant.image && variant.image.url) || '';
    const priceAmt = variant && variant.priceV2 ? variant.priceV2.amount : (p.priceRange && p.priceRange.minVariantPrice ? p.priceRange.minVariantPrice.amount : '');
    const priceCurr = variant && variant.priceV2 ? variant.priceV2.currencyCode : (p.priceRange && p.priceRange.minVariantPrice ? p.priceRange.minVariantPrice.currencyCode : '');
    const compareAmt = variant && variant.compareAtPriceV2 ? variant.compareAtPriceV2.amount : '';
    const compareCurr = variant && variant.compareAtPriceV2 ? variant.compareAtPriceV2.currencyCode : '';
    const available = variant ? !!variant.availableForSale : true;

    const card = document.createElement('div');
    card.className = 'product-card js-product-card product-item';
    card.innerHTML = `
      <div class="featured-product_wrapper">
        <div class="product-card_header">
          <figure class="product-card_image">
            <a href="/products/${escapeHtml(p.handle)}">
              ${ imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(p.title)}" style="max-width:100%;height:auto;display:block;" />` : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#999">No image</div>` }
            </a>
          </figure>
          <div class="product-card_label label_ui-group"></div>
          <div class="featured_product-overlay overlay-ui multi-button-overlay" style="display:none;"></div>
        </div>

        <div class="product-card_body">
          <div class="product-card_row">
            <h3 class="product-card_name">
              <a href="/products/${escapeHtml(p.handle)}">${escapeHtml(p.title)}</a>
            </h3>
          </div>
          <div class="product-card_footer">
            <p class="product-price">
              ${ available ? ( compareAmt && parseFloat(compareAmt) > parseFloat(priceAmt) ? `<span class="price-sale js-money">${escapeHtml(formatMoneyAmt(priceAmt, priceCurr))}</span> <del class="price-compare js-money">${escapeHtml(formatMoneyAmt(compareAmt, compareCurr))}</del>` : `<span class="price js-money">${escapeHtml(formatMoneyAmt(priceAmt, priceCurr))}</span>` ) : `<span class="price soldout">Sold out</span>` }
            </p>
            <div class="product-card_action">
              ${ available && variant && variant.id ? `
                <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-form js-form-add-to-cart" enctype="multipart/form-data" novalidate="novalidate">
                  <input type="hidden" name="utf8" value="✓"/>
                  <input type="hidden" name="id" value="${escapeHtml(plainVariantId)}">
                  <button type="submit" name="add" class="btn btn-add-to-cart" aria-label="Add to cart">
                    <svg class="svg-cart" width="32" height="32" version="1.1" id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px" y="0px" viewBox="0 0 512.002 512.002"
                      style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve">
                      <use xlink:href="#svg-cart"></use>
                    </svg>
                    <svg class="svg-loading" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      style="margin:auto; background:none; shape-rendering:auto;"
                      width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                      <circle cx="50" cy="50" fill="none" stroke="#fdb819" stroke-width="5" r="35"
                        stroke-dasharray="164.93361431346415 56.97787143782138">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                          dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                      </circle>
                    </svg>
                  </button>
                </form>
              ` : '' }
            </div>
          </div>
        </div>
      </div>
    `;
    return card;
  }

  function appendEdgesToGrid(edges, gridEl) {
    edges.forEach(edge => {
      const p = edge.node;
      const card = createProductCardNode(p);
      gridEl.appendChild(card);
    });
  }

  // ---------- application state for pagination ----------
  const STATE = {
    lastQueryString: '',
    lastTerm: '',
    totalCount: 0,
    fetchedEdgesCount: 0,
    endCursor: null,
    hasNextPage: false
  };

  // ---------- render results (can append or replace) ----------
  function renderResults(searchData, termUsed, append = false) {
    if (!searchData) {
      stats.textContent = '';
      resultsContainer.innerHTML = '';
      loadMoreBtn.style.display = 'none';
      return;
    }

    // update state
    const total = parseInt(searchData.totalCount || 0, 10) || 0;
    const edges = searchData.edges || [];
    const pageInfo = searchData.pageInfo || {};
    const hasNext = !!pageInfo.hasNextPage;
    const endCursor = pageInfo.endCursor || null;

    // If this is a fresh render (not append), reset state and clear grid
    if (!append) {
      STATE.lastQueryString = buildQueryString(termUsed);
      STATE.lastTerm = termUsed;
      STATE.totalCount = total;
      STATE.fetchedEdgesCount = 0;
      STATE.endCursor = null;
      STATE.hasNextPage = false;
      resultsContainer.innerHTML = '';
    }

    // Ensure we have a grid element to append into
    let grid = resultsContainer.querySelector('.ipn-grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'ipn-grid product-item';
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(220px, 1fr))';
      grid.style.gap = '20px';
      resultsContainer.appendChild(grid);
    }

    // append edges into grid
    appendEdgesToGrid(edges, grid);

    // update fetched count & state
    STATE.fetchedEdgesCount = (STATE.fetchedEdgesCount || 0) + edges.length;
    STATE.totalCount = total;
    STATE.endCursor = endCursor;
    STATE.hasNextPage = hasNext;

    // update stats text
    stats.textContent = total > 0
      ? `Showing ${STATE.fetchedEdgesCount} of ${STATE.totalCount} RESULTS FOR "${termUsed}"`
      : `0 RESULTS FOR "${termUsed}"`;

    // if there are more pages, show load more button
    if (STATE.hasNextPage) {
      loadMoreBtn.style.display = 'inline-block';
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = 'Load more';
    } else {
      loadMoreBtn.style.display = STATE.fetchedEdgesCount > 0 ? 'none' : 'none';
    }

    // If nothing found, show message
    if (!STATE.fetchedEdgesCount) {
      resultsContainer.innerHTML = '<div style="grid-column:1/-1;padding:18px;background:#fff;border:1px solid #eee;">No products found.</div>';
      loadMoreBtn.style.display = 'none';
    }
  }

  // ---------- logging & error UI ----------
  function debugLog(msg) { console.debug('[IPN search]', msg); }
  function showErrorToUser(message, details) {
    debugArea.textContent = message;
    if (details) console.error('[IPN search details]', details);
  }

  // ---------- search flows ----------
  const suggestDebounced = debounce(async (term) => {
    if (!term || term.length < 1) { suggestions.style.display = 'none'; suggestions.innerHTML = ''; return; }
    const query = buildQueryString(term);
    if (!query) { suggestions.style.display = 'none'; suggestions.innerHTML = ''; return; }

    try {
      const data = await runSearchGraphQL(query, 6);
      if (data && data.edges && data.edges.length) {
        renderSuggestionsFromEdges(data.edges);
        debugArea.textContent = '';
        return;
      }
      suggestions.style.display = 'none';
      suggestions.innerHTML = '';
      return;
    } catch (err) {
      let msg = 'GraphQL returned errors. See console for details.';
      const low = (err && err.message && err.message.toLowerCase()) || '';
      if (low.includes('401') || low.includes('403') || low.includes('permission') || low.includes('access')) {
        msg = 'Storefront token missing/invalid or insufficient scope (401/403). Please verify token and scopes.';
      }
      showErrorToUser(msg, err);

      try {
        const predictiveProducts = await runPredictiveSuggest(term, 6);
        if (predictiveProducts && predictiveProducts.length) {
          renderSuggestionsFromPredictive(predictiveProducts);
          return;
        } else {
          suggestions.style.display = 'none';
          suggestions.innerHTML = '';
          return;
        }
      } catch (pfErr) {
        showErrorToUser('Both GraphQL and predictive fallbacks failed. See console for details.', pfErr);
        suggestions.style.display = 'none';
        suggestions.innerHTML = '';
        return;
      }
    }
  }, 220);

  // helper: reuse your existing render suggestions functions (copied but referencing local names)
  function renderSuggestionsFromEdges(edges) {
    suggestions.innerHTML = '';
    if (!edges || !edges.length) { suggestions.style.display = 'none'; return; }
    edges.forEach(edge => {
      const p = edge.node;
      const variantNode = (p.variants && p.variants.edges && p.variants.edges[0] && p.variants.edges[0].node) || null;
      const variantImg = (variantNode && variantNode.image && variantNode.image.url) || '';
      const img = (p.images && p.images.edges && p.images.edges[0] && p.images.edges[0].node && p.images.edges[0].node.url) || variantImg || '';
      const priceAmt = variantNode && variantNode.priceV2 ? variantNode.priceV2.amount : (p.priceRange && p.priceRange.minVariantPrice ? p.priceRange.minVariantPrice.amount : '');
      const priceCurr = variantNode && variantNode.priceV2 ? variantNode.priceV2.currencyCode : (p.priceRange && p.priceRange.minVariantPrice ? p.priceRange.minVariantPrice.currencyCode : '');
      const price = priceAmt ? formatMoneyAmt(priceAmt, priceCurr) : '';

      const li = document.createElement('li');
      li.className = 'ipn-suggestion-item';
      li.innerHTML = `
        <div class="ipn-suggestion-thumb">${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(p.title)}">` : '<div style="width:56px;height:48px;display:flex;align-items:center;justify-content:center;color:#999">No image</div>'}</div>
        <div class="ipn-suggestion-meta">
          <div class="ipn-suggestion-title">${escapeHtml(p.title)}</div>
          <div class="ipn-suggestion-price">${escapeHtml(price)}</div>
          <div style="display:none;" class="ipn-suggestion-url">/products/${escapeHtml(p.handle)}</div>
        </div>
        
      `;
      li.addEventListener('click', () => { window.location.href = `/products/${p.handle}`; });
      suggestions.appendChild(li);
    });
    suggestions.style.display = 'block';
  }

  function renderSuggestionsFromPredictive(products) {
    suggestions.innerHTML = '';
    if (!products || !products.length) { suggestions.style.display = 'none'; return; }
    products.forEach(prod => {
      const title = prod.title || prod.title_text || '';
      const url = prod.url || (prod.url && prod.url.replace ? prod.url : `/products/${prod.handle || ''}`);
      const img = prod.image || prod.featured_image || (prod.image && prod.image.src) || '';
      const price = prod.price || prod.price_min || '';

      const li = document.createElement('li');
      li.className = 'ipn-suggestion-item';
      li.innerHTML = `
        <div class="ipn-suggestion-thumb">${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(title)}">` : '<div style="width:56px;height:48px;display:flex;align-items:center;justify-content:center;color:#999">No image</div>'}</div>
        <div class="ipn-suggestion-meta">
          <div class="ipn-suggestion-title">${escapeHtml(title)}</div>
          <div class="ipn-suggestion-url">${escapeHtml(url)}</div>
        </div>
        <div class="ipn-suggestion-price">${escapeHtml(price)}</div>
      `;
      li.addEventListener('click', () => {
        if (url && (url.indexOf('/') === 0 || url.indexOf('http') === 0)) {
          window.location.href = url;
        } else if (prod.handle) {
          window.location.href = `/products/${prod.handle}`;
        }
      });
      suggestions.appendChild(li);
    });
    suggestions.style.display = 'Block';
  }

  // ---------- doFullSearch (initial search) ----------
  async function doFullSearch(term) {
    debugArea.textContent = '';
    const query = buildQueryString(term);
    if (!query) { stats.textContent = ''; resultsContainer.innerHTML = ''; loadMoreBtn.style.display = 'none'; return; }
    stats.textContent = 'Searching...';
    resultsContainer.innerHTML = '';
    loadMoreBtn.style.display = 'none';
    STATE.lastQueryString = query;
    STATE.lastTerm = term;
    STATE.fetchedEdgesCount = 0;
    STATE.endCursor = null;
    STATE.hasNextPage = false;
    STATE.totalCount = 0;

    try {
      const data = await runSearchGraphQL(query, 48, null);
      renderResults(data, term, false);
    } catch (err) {
      let userMsg = 'Search failed. See console for details.';
      const low = (err && err.message && err.message.toLowerCase()) || '';
      if (low.includes('401') || low.includes('403')) {
        userMsg = 'Search failed: Storefront token may be invalid or missing required scopes (401/403).';
      } else if (low.includes('network') || low.includes('fetch')) {
        userMsg = 'Search failed: Network/CORS error when calling GraphQL endpoint.';
      }
      showErrorToUser(userMsg, err);
      stats.textContent = '';
      loadMoreBtn.style.display = 'none';
    }
  }

  // ---------- load more handler (fetch next page using endCursor) ----------
  async function loadMore() {
    if (!STATE.hasNextPage || !STATE.endCursor) return;
    loadMoreBtn.disabled = true;
    const origText = loadMoreBtn.textContent;
    loadMoreBtn.textContent = 'Loading...';
    try {
      const data = await runSearchGraphQL(STATE.lastQueryString, 48, STATE.endCursor);
      // append results
      renderResults(data, STATE.lastTerm, true);
    } catch (err) {
      console.error('[IPN] load more failed', err);
      ipnShowMessage('Could not load more results', true);
      // keep load more visible so user can retry
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = origText;
    }
  }

  // small user message helper
  function ipnShowMessage(msg, isError = false, timeout = 3500) {
    let el = document.getElementById('ipn-add-msg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ipn-add-msg';
      el.style.position = 'fixed';
      el.style.right = '18px';
      el.style.bottom = '18px';
      el.style.zIndex = 99999;
      el.style.padding = '10px 14px';
      el.style.borderRadius = '6px';
      el.style.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
      document.body.appendChild(el);
    }
    el.style.background = isError ? '#fbeaea' : '#eafaf1';
    el.style.color = isError ? '#a00' : '#085a23';
    el.textContent = msg;
    el.style.display = 'block';
    if (timeout) clearTimeout(el._t), el._t = setTimeout(()=> el.style.display = 'none', timeout);
  }

  // ---------- events ----------
  input.addEventListener('input', (e) => {
    const v = e.target.value.trim();
    suggestDebounced(v);
  });

  // Enter key still triggers full search
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      suggestions.style.display = 'none';
      doFullSearch(input.value.trim());
    } else if (e.key === 'Escape') {
      suggestions.style.display = 'none';
    }
  });

  // Buttons: Search & Reset
  searchBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    suggestions.style.display = 'none';
    doFullSearch(input.value.trim());
  });

  resetBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    input.value = '';
    suggestions.style.display = 'none';
    suggestions.innerHTML = '';
    resultsContainer.innerHTML = '';
    stats.textContent = '';
    debugArea.textContent = '';
    STATE.lastQueryString = '';
    STATE.lastTerm = '';
    STATE.totalCount = 0;
    STATE.fetchedEdgesCount = 0;
    STATE.endCursor = null;
    STATE.hasNextPage = false;
    loadMoreBtn.style.display = 'none';
    input.focus();
  });

  loadMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (!STATE.hasNextPage) return;
    loadMore();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.ipn-search-controls')) suggestions.style.display = 'none';
  });

  // Auto-run if ?q= present
  const params = new URLSearchParams(window.location.search);
  if (params.has('q')) {
    const q = params.get('q');
    input.value = q;
    setTimeout(() => { doFullSearch(q); }, 250);
  }

  // ---------- Add-to-cart handler (ensures numeric id before theme submits, shows spinner) ----------
  if (!window._ipn_add_to_cart_attached) {
    window._ipn_add_to_cart_attached = true;

    // Let theme handle form if it can (preferred so popup opens).
    function tryThemeHandleFormWithPromise(form) {
      try {
        if (window.Cart && typeof window.Cart.add === 'function') {
          const result = window.Cart.add(form);
          if (result && typeof result.then === 'function') return { handled: true, promise: result };
          return { handled: true, promise: null };
        }
        if (window.theme && window.theme.Cart && typeof window.theme.Cart.add === 'function') {
          const result = window.theme.Cart.add(form);
          if (result && typeof result.then === 'function') return { handled: true, promise: result };
          return { handled: true, promise: null };
        }
        const ev = new Event('submit', { bubbles: true, cancelable: true });
        const defaultNotPrevented = form.dispatchEvent(ev);
        if (!defaultNotPrevented) {
          return { handled: true, promise: null };
        }
      } catch (e) {
        console.warn('[IPN] tryThemeHandleFormWithPromise error', e);
      }
      return { handled: false, promise: null };
    }

    function setButtonPending(btn) { if (!btn) return; btn.classList.add('pending'); try { btn.disabled = true; } catch(e){} }
    function clearButtonPending(btn) { if (!btn) return; btn.classList.remove('pending'); try { btn.disabled = false; } catch(e){} }

    document.addEventListener('submit', async function(e) {
      const form = e.target;
      if (!form || !form.classList || !form.classList.contains('js-form-add-to-cart')) return;

      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        const original = idInput.value;
        const conv = variantIdToPlain(original);
        if (conv !== original) idInput.value = conv;
      }

      let submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!submitBtn) submitBtn = form.querySelector('.btn.btn-add-to-cart');

      e.preventDefault();
      if (submitBtn) setButtonPending(submitBtn);

      try {
        const { handled, promise } = tryThemeHandleFormWithPromise(form);
        if (handled) {
          if (promise && typeof promise.then === 'function') {
            try {
              await promise;
              clearButtonPending(submitBtn);
              return;
            } catch (err) {
              clearButtonPending(submitBtn);
              ipnShowMessage('Could not add to cart', true);
              return;
            }
          } else {
            setTimeout(()=> clearButtonPending(submitBtn), 2500);
            return;
          }
        }
      } catch (err) {
        console.warn('[IPN] theme handle attempt failed; falling back to fetch', err);
      }

      const qtyInput = form.querySelector('input[name="quantity"]') || form.querySelector('input[name="qty"]');
      const qty = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
      let variantId = idInput ? idInput.value : null;
      if (!variantId) { ipnShowMessage('Variant id not found (cannot add)', true); clearButtonPending(submitBtn); return; }
      variantId = variantIdToPlain(variantId);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty }),
          credentials: 'same-origin'
        });

        const raw = await res.clone().text().catch(()=>null);
        if (!res.ok) {
          console.error('[IPN] /cart/add failed', res.status, raw);
          ipnShowMessage('Cart Error: could not add item', true);
          clearButtonPending(submitBtn);
          return;
        }

        const json = await res.json().catch(()=>null);
        ipnShowMessage('Added to cart');
        setTimeout(() => clearButtonPending(submitBtn), 400);
      } catch (err) {
        console.error('[IPN] add to cart error', err);
        ipnShowMessage('Could not add to cart', true);
        clearButtonPending(submitBtn);
      }
    }, false);

    // Click handler for elements with data-add-variant attribute (alternative add buttons)
    document.addEventListener('click', async function(e) {
      const t = e.target;
      const el = (t.closest && t.closest('[data-add-variant]')) || (t.matches && t.matches('[data-add-variant]') ? t : null);
      if (!el) return;
      e.preventDefault();

      const rawVariant = el.getAttribute('data-add-variant');
      const qty = parseInt(el.getAttribute('data-add-qty') || '1', 10) || 1;
      if (!rawVariant) { ipnShowMessage('Variant ID missing', true); return; }

      try {
        const tmp = document.createElement('form');
        tmp.style.display = 'none';
        tmp.className = 'js-form-add-to-cart ipn-temp-add-form';
        tmp.method = 'post';
        tmp.action = '/cart/add';
        const inputId = document.createElement('input'); inputId.type = 'hidden'; inputId.name = 'id'; inputId.value = variantIdToPlain(rawVariant); tmp.appendChild(inputId);
        const inputQty = document.createElement('input'); inputQty.type = 'hidden'; inputQty.name = 'quantity'; inputQty.value = String(qty); tmp.appendChild(inputQty);
        document.body.appendChild(tmp);

        const tmpBtn = document.createElement('button');
        tmpBtn.type = 'button';
        tmpBtn.style.display = 'none';
        tmpBtn.className = 'btn btn-add-to-cart';
        document.body.appendChild(tmpBtn);
        setButtonPending(tmpBtn);

        const { handled, promise } = tryThemeHandleFormWithPromise(tmp);
        if (handled) {
          if (promise && typeof promise.then === 'function') {
            try { await promise; } catch (err) { ipnShowMessage('Could not add to cart', true); }
            clearButtonPending(tmpBtn);
            tmp.remove(); tmpBtn.remove();
            return;
          } else {
            setTimeout(()=>{ clearButtonPending(tmpBtn); tmp.remove(); tmpBtn.remove(); }, 2500);
            return;
          }
        }
        tmp.remove(); tmpBtn.remove();
      } catch (err) {
        console.warn('[IPN] temp form theme attempt failed', err);
      }

      const variantId = variantIdToPlain(rawVariant);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty }),
          credentials: 'same-origin'
        });
        const raw = await res.clone().text().catch(()=>null);
        if (!res.ok) {
          console.error('[IPN] /cart/add (click fallback) failed', res.status, raw);
          ipnShowMessage('Cart Error', true);
          return;
        }
        ipnShowMessage('Added to cart');
      } catch (err) {
        console.error('[IPN] click add-to-cart error', err);
        ipnShowMessage('Could not add to cart', true);
      }
    }, false);
  }

})();
